// src/component/Pricing.js
import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";

const TELEGRAM_USERNAME = "exammastery_support";

const PLANS = [
  {
    category:  "🎓 University Exit Exams",
    color:     "#31b3ba",
    glow:      "rgba(49,179,186,0.25)",
    icon:      "🏛️",
    plans: [
      {
        title:    "Exit-Exam Pro",
        subtitle: "For serious exam takers",
        price:    "499",
        badge:    null,
        features: [
          "300 expert-level exam questions",
          "Full detailed answer explanations",
          "Unlimited practice attempts",
          "Performance tracking",
        ],
      },
      {
        title:    "Full Bundle",
        subtitle: "Everything you need",
        price:    "650",
        badge:    "🔥 BEST VALUE",
        features: [
          "All Exit-Exam Pro features",
          "300 Foundation mastery questions",
          "Complete course study notes",
          "Priority Telegram support",
        ],
      },
    ],
  },
  {
    category:  "📝 Grade 12 National Exams",
    color:     "#a855f7",
    glow:      "rgba(168,85,247,0.25)",
    icon:      "📚",
    plans: [
      {
        title:    "National Exam Pro",
        subtitle: "Grade 12 focused prep",
        price:    "299",
        badge:    null,
        features: [
          "Full official question bank",
          "Detailed explanations",
          "All subjects covered",
          "Practice mode",
        ],
      },
      {
        title:    "National Full Bundle",
        subtitle: "Every subject, every topic",
        price:    "999",
        badge:    "⭐ POPULAR",
        features: [
          "All subjects — National Exam Pro",
          "Comprehensive study notes",
          "Mastery level drills",
          "Exam tips & strategies",
        ],
      },
    ],
  },
  {
    category:  "🏛️ GAT & Professional Exams",
    color:     "#f59e0b",
    glow:      "rgba(245,158,11,0.25)",
    icon:      "🎯",
    plans: [
      {
        title:    "Professional Exam Pro",
        subtitle: "Airlines, Bank & GAT",
        price:    "399",
        badge:    null,
        features: [
          "Airlines, Bank & GAT questions",
          "Professional exam format",
          "Detailed answer explanations",
          "Unlimited attempts",
        ],
      },
      {
        title:    "Professional Bundle",
        subtitle: "Full prep suite",
        price:    "500",
        badge:    "💎 COMPLETE",
        features: [
          "All Professional Exam Pro features",
          "Full reference study notes",
          "Formula & concept sheets",
          "Dedicated Telegram support",
        ],
      },
    ],
  },
];

const openTelegram = (planTitle, price) => {
  const message = `Hello! I want to get access to: ${planTitle} (${price} ETB) on Ethio Exam Mastery. Please guide me on how to pay.`;
  const url = `https://t.me/${TELEGRAM_USERNAME}?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

const FloatingOrb = ({ style }) => (
  <div style={{
    position: "absolute",
    borderRadius: "50%",
    filter: "blur(60px)",
    pointerEvents: "none",
    opacity: 0.12,
    ...style,
  }} />
);

export const Pricing = () => {
  const [hoveredCard, setHoveredCard] = useState(null);
  const [psHovered,   setPsHovered]   = useState(false);

  return (
    <section id="pricing" style={styles.section}>

      {/* Ambient background orbs */}
      <FloatingOrb style={{ width: 500, height: 500, background: "#31b3ba", top: -100, left: -100 }} />
      <FloatingOrb style={{ width: 400, height: 400, background: "#a855f7", top: 200, right: -80 }} />
      <FloatingOrb style={{ width: 350, height: 350, background: "#f59e0b", bottom: 100, left: "30%" }} />

      {/* Grid overlay */}
      <div style={styles.gridOverlay} />

      <Container style={{ position: "relative", zIndex: 2 }}>

        {/* ── Hero header ──────────────────────────────────────── */}
        <div style={{ textAlign: "center", marginBottom: "70px" }}>

          {/* ══════════════════════════════════════════════════════
              PLAY STORE BUTTON  — centered, above Premium Plans
          ══════════════════════════════════════════════════════ */}
          <div style={styles.psBlock}>

            {/* Pulsing badge */}
            <div style={styles.psBadge}>
              <span style={styles.psBadgeDot} />
              Free to download &nbsp;·&nbsp; 50,000+ students learning
            </div>

            {/* Button */}
            <a
              href="https://play.google.com/store/apps/details?id=com.ethio.exam_mastery"
              target="_blank"
              rel="noreferrer"
              style={{
                ...styles.psBtn,
                ...(psHovered ? styles.psBtnHover : {}),
              }}
              onMouseEnter={() => setPsHovered(true)}
              onMouseLeave={() => setPsHovered(false)}
            >
              {/* Animated pulse ring */}
              <span style={styles.psPulse} />

              {/* Icon bubble */}
              <div style={{
                ...styles.psIconWrap,
                ...(psHovered ? styles.psIconWrapHover : {}),
              }}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <path d="M3.18 23.4C3.06 23.1 3 22.77 3 22.38V1.62C3 1.23 3.06 0.9 3.18 0.6L13.38 12L3.18 23.4Z" fill="white"/>
                  <path d="M16.96 15.28L5.04 22.42L13.38 12L16.96 15.28Z" fill="white" fillOpacity="0.8"/>
                  <path d="M19.98 10.86L17.38 12L19.98 13.14C20.58 13.5 20.58 14.5 19.98 14.86L17.38 16.38L13.38 12L17.38 7.62L19.98 9.14C20.58 9.5 20.58 10.5 19.98 10.86Z" fill="white"/>
                  <path d="M5.04 1.58L16.96 8.72L13.38 12L5.04 1.58Z" fill="white" fillOpacity="0.8"/>
                </svg>
              </div>

              {/* Text */}
              <div style={styles.psTextGroup}>
                <span style={styles.psSubLabel}>Get the App from</span>
                <span style={styles.psMainLabel}>Google Play Store</span>
              </div>

              {/* Arrow */}
              <svg
                style={{
                  ...styles.psArrow,
                  ...(psHovered ? styles.psArrowHover : {}),
                }}
                width="18" height="18" viewBox="0 0 24 24"
                fill="none" stroke="rgba(49,179,186,0.85)"
                strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
              >
                <path d="M5 12h14"/>
                <path d="m12 5 7 7-7 7"/>
              </svg>
            </a>

            {/* Divider beneath button */}
            <div style={styles.psDivider} />
          </div>
          {/* ══════════════ end Play Store button ══════════════ */}

          {/* Premium Plans badge */}
          <div style={styles.heroTopBadge}>
            <span style={{ marginRight: 6 }}>✦</span> Premium Plans
          </div>

          <h1 style={styles.heroTitle}>
            Unlock Your{" "}
            <span style={styles.heroGradientText}>Exam Success</span>
          </h1>

          <p style={styles.heroSubtitle}>
            Join thousands of students who passed with Ethio Exam Mastery.
            <br />Contact us on Telegram — we activate your access within minutes.
          </p>

          {/* Telegram CTA banner */}
          <a
            href={`https://t.me/${TELEGRAM_USERNAME}`}
            target="_blank"
            rel="noreferrer"
            style={styles.telegramBanner}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(33,150,217,0.25)";
              e.currentTarget.style.transform  = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "rgba(33,150,217,0.12)";
              e.currentTarget.style.transform  = "translateY(0)";
            }}
          >
            <span style={{ fontSize: "1.3rem" }}>✈️</span>
            <div style={{ textAlign: "left" }}>
              <div style={{ color: "#4fc3f7", fontWeight: 800, fontSize: "0.95rem" }}>
                Contact us on Telegram
              </div>
              <div style={{ color: "#999", fontSize: "0.78rem" }}>
                @{TELEGRAM_USERNAME} · Fast response · Payment in minutes
              </div>
            </div>
            <span style={{ color: "#4fc3f7", fontSize: "1.2rem", marginLeft: "auto" }}>→</span>
          </a>

          {/* Trust badges */}
          <div style={styles.trustRow}>
            {["⚡ Instant Activation", "📱 Works on App", "🔒 Secure Payment", "💬 24/7 Support"].map((t) => (
              <span key={t} style={styles.trustBadge}>{t}</span>
            ))}
          </div>
        </div>

        {/* ── Plan groups ───────────────────────────────────────── */}
        {PLANS.map((group) => (
          <div key={group.category} style={{ marginBottom: "72px" }}>
            {/* Category header */}
            <div style={{ textAlign: "center", marginBottom: "32px" }}>
              <div style={{ ...styles.categoryPill, borderColor: group.color, color: group.color }}>
                <span>{group.icon}</span>
                <span>{group.category}</span>
              </div>
            </div>

            <Row className="justify-content-center g-4">
              {group.plans.map((plan, i) => {
                const cardKey  = `${group.category}-${i}`;
                const isHovered = hoveredCard === cardKey;
                const isBest    = plan.badge !== null;

                return (
                  <Col key={plan.title} xs={12} sm={10} md={5} lg={4}>
                    <div
                      style={{
                        ...styles.card,
                        borderColor: isHovered || isBest ? group.color : "rgba(255,255,255,0.08)",
                        boxShadow: isHovered
                          ? `0 0 40px ${group.glow}, 0 20px 60px rgba(0,0,0,0.4)`
                          : isBest
                          ? `0 0 24px ${group.glow}`
                          : "0 8px 32px rgba(0,0,0,0.25)",
                        transform: isHovered ? "translateY(-8px) scale(1.01)" : "translateY(0) scale(1)",
                        background: isBest
                          ? "linear-gradient(145deg, rgba(255,255,255,0.07), rgba(255,255,255,0.03))"
                          : "rgba(255,255,255,0.04)",
                      }}
                      onMouseEnter={() => setHoveredCard(cardKey)}
                      onMouseLeave={() => setHoveredCard(null)}
                    >
                      {/* Badge */}
                      {plan.badge && (
                        <div style={{ ...styles.planBadge, background: group.color }}>
                          {plan.badge}
                        </div>
                      )}

                      {/* Plan header */}
                      <div style={{ marginBottom: "20px" }}>
                        <h4 style={{ color: group.color, fontWeight: 800, fontSize: "1.15rem", marginBottom: 4 }}>
                          {plan.title}
                        </h4>
                        <p style={{ color: "#888", fontSize: "0.82rem", margin: 0 }}>
                          {plan.subtitle}
                        </p>
                      </div>

                      {/* Price */}
                      <div style={styles.priceRow}>
                        <div>
                          <span style={{ color: "#fff", fontSize: "2.8rem", fontWeight: 900, lineHeight: 1 }}>
                            {plan.price}
                          </span>
                          <span style={{ color: "#777", fontSize: "1rem", marginLeft: 6 }}>ETB</span>
                        </div>
                        <div style={{
                          ...styles.pricePill,
                          background: `${group.color}22`,
                          color: group.color,
                        }}>
                          One-time
                        </div>
                      </div>

                      {/* Divider */}
                      <div style={{ ...styles.divider, background: group.color }} />

                      {/* Features */}
                      <ul style={{ listStyle: "none", padding: 0, margin: "0 0 24px" }}>
                        {plan.features.map((f, fi) => (
                          <li key={fi} style={styles.featureItem}>
                            <span style={{
                              ...styles.checkIcon,
                              background: `${group.color}22`,
                              color: group.color,
                            }}>✓</span>
                            <span style={{ color: "#ccc", fontSize: "0.88rem" }}>{f}</span>
                          </li>
                        ))}
                      </ul>

                      {/* CTA */}
                      <button
                        onClick={() => openTelegram(plan.title, plan.price)}
                        style={{
                          ...styles.ctaBtn,
                          background: isBest
                            ? `linear-gradient(135deg, ${group.color}, ${group.color}cc)`
                            : "transparent",
                          border: `2px solid ${group.color}`,
                          color: isBest ? "#fff" : group.color,
                          boxShadow: isHovered ? `0 0 20px ${group.glow}` : "none",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = group.color;
                          e.currentTarget.style.color      = "#fff";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = isBest
                            ? `linear-gradient(135deg, ${group.color}, ${group.color}cc)`
                            : "transparent";
                          e.currentTarget.style.color = isBest ? "#fff" : group.color;
                        }}
                      >
                        <span style={{ marginRight: 8 }}>✈️</span>
                        Get Access — {plan.price} ETB
                      </button>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        ))}

        {/* ── Bottom note ─────────────────────────────────────── */}
        <div style={styles.bottomNote}>
          <div style={{ fontSize: "1.5rem", marginBottom: 10 }}>🚀</div>
          <p style={{ color: "#ccc", fontWeight: 600, margin: "0 0 6px" }}>
            How does it work?
          </p>
          <p style={{ color: "#888", fontSize: "0.85rem", margin: 0 }}>
            Tap any plan → Contact us on Telegram → We send payment details → Access activated within minutes.
            <br />Your subscription is linked to your app account automatically.
          </p>
        </div>

      </Container>

      <style>{`
        @keyframes psBadgePulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50%       { opacity: 0.4; transform: scale(1.2); }
        }
        @keyframes psRing {
          0%   { opacity: 0.65; transform: scale(1); }
          100% { opacity: 0;    transform: scale(1.08); }
        }
      `}</style>
    </section>
  );
};

// ── Styles ────────────────────────────────────────────────────────
const styles = {
  section: {
    padding: "100px 0 90px",
    background: "linear-gradient(160deg, #080f1e 0%, #0c1a30 50%, #080f1e 100%)",
    position: "relative",
    overflow: "hidden",
    minHeight: "100vh",
  },
  gridOverlay: {
    position: "absolute",
    inset: 0,
    backgroundImage: `
      linear-gradient(rgba(49,179,186,0.035) 1px, transparent 1px),
      linear-gradient(90deg, rgba(49,179,186,0.035) 1px, transparent 1px)
    `,
    backgroundSize: "44px 44px",
    pointerEvents: "none",
  },

  /* ── Play Store button block ── */
  psBlock: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: 36,
  },
  psBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    background: "rgba(49,179,186,0.1)",
    border: "1px solid rgba(49,179,186,0.25)",
    borderRadius: 20,
    padding: "4px 14px",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.4px",
    color: "#31b3ba",
    marginBottom: 12,
  },
  psBadgeDot: {
    display: "inline-block",
    width: 6,
    height: 6,
    borderRadius: "50%",
    background: "#31b3ba",
    animation: "psBadgePulse 1.8s ease-in-out infinite",
  },
  psBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: 14,
    padding: "13px 24px 13px 18px",
    background: "linear-gradient(135deg, #111827 0%, #0d1420 100%)",
    border: "1.5px solid rgba(49,179,186,0.4)",
    borderRadius: 14,
    textDecoration: "none",
    cursor: "pointer",
    position: "relative",
    overflow: "hidden",
    transition: "transform 0.28s cubic-bezier(.34,1.56,.64,1), border-color 0.25s, box-shadow 0.28s",
    boxShadow: "0 4px 20px rgba(49,179,186,0.15), inset 0 1px 0 rgba(255,255,255,0.05)",
  },
  psBtnHover: {
    transform: "translateY(-4px) scale(1.03)",
    borderColor: "rgba(49,179,186,0.75)",
    boxShadow: "0 14px 44px rgba(49,179,186,0.30), 0 0 0 1px rgba(49,179,186,0.12), inset 0 1px 0 rgba(255,255,255,0.08)",
  },
  psPulse: {
    position: "absolute",
    inset: -2,
    borderRadius: 16,
    border: "1.5px solid rgba(49,179,186,0.45)",
    animation: "psRing 2.4s ease-out infinite",
    pointerEvents: "none",
  },
  psIconWrap: {
    width: 44,
    height: 44,
    borderRadius: 10,
    background: "linear-gradient(135deg, #31b3ba, #1a8f96)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    boxShadow: "0 4px 14px rgba(49,179,186,0.38)",
    position: "relative",
    zIndex: 1,
    transition: "transform 0.3s cubic-bezier(.34,1.56,.64,1)",
  },
  psIconWrapHover: {
    transform: "rotate(-8deg) scale(1.12)",
  },
  psTextGroup: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    zIndex: 1,
  },
  psSubLabel: {
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: "1.2px",
    textTransform: "uppercase",
    color: "rgba(156,163,175,0.8)",
    lineHeight: 1,
    marginBottom: 4,
  },
  psMainLabel: {
    fontSize: 15,
    fontWeight: 800,
    color: "#ffffff",
    lineHeight: 1,
    letterSpacing: "0.2px",
  },
  psArrow: {
    marginLeft: 8,
    position: "relative",
    zIndex: 1,
    transition: "transform 0.22s ease",
    flexShrink: 0,
  },
  psArrowHover: {
    transform: "translateX(5px)",
  },
  psDivider: {
    width: 120,
    height: 1,
    background: "linear-gradient(90deg, transparent, rgba(49,179,186,0.3), transparent)",
    marginTop: 28,
  },

  /* ── Hero header ── */
  heroTopBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    background: "rgba(49,179,186,0.1)",
    border: "1px solid rgba(49,179,186,0.35)",
    color: "#31b3ba",
    borderRadius: 50,
    padding: "5px 18px",
    fontSize: "0.75rem",
    letterSpacing: "1.5px",
    fontWeight: 700,
    textTransform: "uppercase",
    marginBottom: 20,
  },
  heroTitle: {
    color: "#fff",
    fontSize: "clamp(2rem, 5vw, 3.2rem)",
    fontWeight: 900,
    margin: "0 0 16px",
    lineHeight: 1.15,
  },
  heroGradientText: {
    background: "linear-gradient(135deg, #31b3ba, #a855f7)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  },
  heroSubtitle: {
    color: "#9ca3af",
    fontSize: "1.05rem",
    lineHeight: 1.7,
    margin: "0 0 28px",
  },
  telegramBanner: {
    display: "inline-flex",
    alignItems: "center",
    gap: 14,
    background: "rgba(33,150,217,0.12)",
    border: "1px solid rgba(33,150,217,0.3)",
    borderRadius: 16,
    padding: "14px 24px",
    textDecoration: "none",
    marginBottom: 28,
    transition: "all 0.25s ease",
    minWidth: 320,
  },
  trustRow: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: 10,
  },
  trustBadge: {
    background: "rgba(255,255,255,0.05)",
    border: "1px solid rgba(255,255,255,0.1)",
    color: "#aaa",
    borderRadius: 50,
    padding: "5px 14px",
    fontSize: "0.78rem",
    fontWeight: 600,
  },

  /* ── Plan cards ── */
  categoryPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    border: "1px solid",
    borderRadius: 50,
    padding: "8px 20px",
    fontSize: "0.9rem",
    fontWeight: 700,
  },
  card: {
    borderRadius: 24,
    padding: "32px 26px 26px",
    position: "relative",
    border: "1.5px solid",
    backdropFilter: "blur(12px)",
    transition: "all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)",
    height: "100%",
    cursor: "default",
  },
  planBadge: {
    position: "absolute",
    top: -14,
    left: "50%",
    transform: "translateX(-50%)",
    color: "#000",
    fontSize: "0.65rem",
    fontWeight: 900,
    letterSpacing: "1.2px",
    padding: "5px 16px",
    borderRadius: 50,
    whiteSpace: "nowrap",
  },
  priceRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 16,
  },
  pricePill: {
    borderRadius: 50,
    padding: "4px 12px",
    fontSize: "0.72rem",
    fontWeight: 700,
  },
  divider: {
    height: 1,
    opacity: 0.2,
    borderRadius: 1,
    marginBottom: 18,
  },
  featureItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: 10,
    marginBottom: 10,
  },
  checkIcon: {
    borderRadius: "50%",
    width: 20,
    height: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "0.65rem",
    fontWeight: 900,
    flexShrink: 0,
    marginTop: 1,
  },
  ctaBtn: {
    width: "100%",
    padding: "13px",
    borderRadius: 12,
    fontWeight: 800,
    fontSize: "0.92rem",
    cursor: "pointer",
    transition: "all 0.2s ease",
    letterSpacing: "0.3px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  bottomNote: {
    textAlign: "center",
    marginTop: 10,
    padding: "28px 24px",
    background: "rgba(255,255,255,0.03)",
    borderRadius: 18,
    border: "1px solid rgba(255,255,255,0.06)",
  },
};